var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        title: "Videos",
        size: "xl",
        "hide-footer": "",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "recordings-container" },
        [
          _vm.recordings.length
            ? _c(
                "ul",
                { staticClass: "recordings__list" },
                _vm._l(_vm.recordings, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.id,
                      staticClass: "list-item",
                      class: { active: item.id === _vm.uploadedVideoFile },
                    },
                    [
                      _c("div", { staticClass: "recordings__list-item" }, [
                        _c("video", { attrs: { src: item.url, controls: "" } }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-item__controls" }, [
                        _c(
                          "button",
                          {
                            staticClass: "unstyled-btn font-weight-bold",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return (() => _vm.handleRenameBtn(item)).apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_c("b-icon", { attrs: { icon: "pencil" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "unstyled-btn font-weight-bold",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return (() =>
                                  _vm.handleDownloadBtn(
                                    item.path,
                                    item.name
                                  )).apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon", { attrs: { icon: "download" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "unstyled-btn font-weight-bold",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return (() =>
                                  _vm.handleShareBtn(item.id)).apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_c("b-icon", { attrs: { icon: "share-fill" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "unstyled-btn font-weight-bold",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return (() =>
                                  _vm.$emit("delete", item.id)).apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("b-icon", {
                              attrs: { icon: "trash", variant: "danger" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "list-item__name" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.name) +
                            "." +
                            _vm._s(item.type) +
                            "\n        "
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "no-recordings mb-3" }, [
                _vm._v("\n      No records yet\n    "),
              ]),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              value: _vm.currentPage,
              "total-rows": _vm.total,
              "per-page": "10",
            },
            on: { change: (page) => _vm.$emit("pageChanged", page) },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ShareLinkModal", { attrs: { "share-link": _vm.shareLink } }),
      _vm._v(" "),
      _c("RenameModal", {
        attrs: { item: _vm.currentVideo },
        on: {
          change: (name) =>
            _vm.$emit("changeName", { id: _vm.currentVideo.id, name }),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }